module.exports = __webpack_public_path__ + "img/Convertible_Front_Side_Left_Transparent.8b84623a.svg";